import { pgEnum, pgTable, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { estates } from "./estate"
import { users } from "./users"

// enums
export const journalPriorityEnum = pgEnum("journal_priority", ["HIGH", "MEDIUM", "LOW"])
export const journalTypeEnum = pgEnum("journal_type", [
  "CHARITABLE_DONATION",
  "FUNERAL_ARRANGEMENTS",
  "DEBT",
  "INSURANCE_DETAILS",
  "COMMITTEE_SHIP",
  "PERSONAL_ITEM",
  "FAMILY_HEIRLOOM",
  "REAL_ESTATE",
  "WILL_DETAILS",
  "TRUST_DETAILS",
  "GUARDIANSHIP",
  "HEALTH_DIRECTIVE",
  "LEGAL",
  "RETIREMENT_DETAILS",
  "OTHER",
  "COLLABORATOR",
  "MEMORIAL_DETAILS",
  "DIGITAL_ACCOUNT",
  "BUSINESS_DETAILS",
  "BANKING_DETAILS",
  "FINANCIAL_PLANNING",
  "INVESTMENTS",
  "POWER_OF_ATTORNEY_DETAILS",
  "EXECUTOR_DETAILS",
  "ACCOUNTING",
  "TAXES",
  "BOOKKEEPING",
])
export const commIntervalEnum = pgEnum("comm_interval", ["DAILY", "WEEKLY", "MONTHLY", "YEARLY"])
export const smsStatusEnum = pgEnum("sms_status", ["ACTIVE", "PENDING", "DEACTIVATED"])

// Purpose: Records important notes, communications, or events related to an estate, contact, or document.
export const journals = pgTable("journal", {
  id: uuid("id").primaryKey().defaultRandom(),
  journalType: journalTypeEnum("journal_type").notNull(),
  commInterval: commIntervalEnum("comm_interval").notNull(),
  smsStatus: smsStatusEnum("sms_status").notNull(),
  journalPriority: journalPriorityEnum("journal_priority").notNull(),
  createdById: varchar("created_by_user_id", { length: 255 })
    .notNull()
    .references(() => users.id, { onDelete: "cascade" }),
  name: varchar("name", { length: 255 }).notNull(),
  description: text("description"),
  journalNote: text("journal_note"),
  estateId: uuid("estate_id")
    .notNull()
    .references(() => estates.id, { onDelete: "cascade" }),
  entryDate: timestamp("entry_date").defaultNow().notNull(),
  content: text("content").notNull(),
  createdAt: timestamp("created_at").defaultNow().notNull(),
  // Note: For 'ON UPDATE CURRENT_TIMESTAMP' functionality in PostgreSQL,
  // a database trigger is required. This schema sets the timestamp on creation,
  // and application logic or a trigger should handle updates.
  updatedAt: timestamp("updated_at").defaultNow().notNull(),
})
